export default __webpack_public_path__ + "static/media/undersea-linear-template.a641f1d5.png";